import styled from "styled-components";

export const UnitText = styled.div`
  display: flex;
  top: -10px;
  right: 30px;
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.3rem;
  font-weight: 600;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;

  span {
    color: ${(props) => props.theme.colors.text2};
    font-size: 1.2rem;
    font-weight: 400;
  }
`;
